import React from "react"
import PropTypes from "prop-types"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"

/**
 * Component to display a row of widget view model attribute.
 */
export default function WidgetRowInfo({ name, value }) {
  return (
    <Box>
      <Typography display="inline" className="tag-label">
        {name}
      </Typography>
      <Typography display="inline">{value}</Typography>
    </Box>
  )
}

WidgetRowInfo.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string
}

WidgetRowInfo.defaultProps = {
  value: ""
}
